// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"y4-z","colorTextValue":"z4-z","swatches":"A4-z","collapseLink":"B4-z","isCollapsed":"C4-z","dropdown":"D4-z","disabled":"E4-z"};